var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewDetailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.16667V1.16667C12 0.989856 11.9298 0.820286 11.8047 0.695262C11.6797 0.570238 11.5101 0.5 11.3333 0.5H7.33333V1.83333H9.72375L6.39067 5.16667L7.33333 6.10933L10.6667 2.77625V5.16667H12ZM0 7.83333V11.8333C0 12.0101 0.0702379 12.1797 0.195262 12.3047C0.320286 12.4298 0.489856 12.5 0.666667 12.5H4.66667V11.1667H2.27625L5.60933 7.83333L4.66667 6.89067L1.33333 10.2237V7.83333H0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDetailIcon);
export default __webpack_public_path__ + "static/media/viewDetailIcon.ca64a75557793b233053e705b2840db3.svg";
export { ForwardRef as ReactComponent };